import React from "react";
import { Helmet } from "react-helmet";
import "../css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Aaradhya Travels | Terms & Conditions</title>

        <meta
          name="description"
          content="Terms & Conditions for Aaradhya Travels cab booking, local travel, outstation tours, and rental services."
        />
      </Helmet>

        <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Terms & Conditions
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      {/* Terms Section */}
      <section className="terms-section">

        <div className="container">

          <div className="row g-0">

            <img className="img-fluid" src="/images/term.png" />

            <div className="col-md-12">

              <div className="terms-content">

                <p>
                  <b className="highlight">
                    1. Booking Confirmation:
                  </b>
                  <br />

                  All bookings with Aaradhya Travels are subject to
                  vehicle availability. Booking confirmation will be
                  provided only after receiving advance payment or
                  approval from our team.
                </p>

                <p>
                  <b className="highlight">
                    2. Vehicle Usage:
                  </b>
                  <br />

                  Vehicles are strictly provided for passenger
                  transportation purposes only. Carrying illegal,
                  hazardous, or commercial goods is prohibited.
                </p>

                <p>
                  <b className="highlight">
                    3. Payment Policy:
                  </b>
                  <br />

                  Payments can be made through UPI, bank transfer,
                  online payment, or cash. Advance payment may be
                  required for outstation trips, tour packages,
                  corporate bookings, and special events.
                </p>

                <p>
                  <b className="highlight">
                    4. Cancellation & Rescheduling:
                  </b>
                  <br />

                  Cancellation requests must be informed in advance.
                  Cancellation charges may apply depending on booking
                  type and timing.
                </p>

                <p>
                  <b className="highlight">
                    5. Passenger Responsibility:
                  </b>
                  <br />

                  Customers must provide accurate pickup and drop
                  details. Any delay caused by incorrect information
                  may result in additional waiting charges.
                </p>

                <p>
                  <b className="highlight">
                    6. Seating & Luggage:
                  </b>
                  <br />

                  Passenger count should not exceed the seating
                  capacity of the vehicle. Extra luggage beyond the
                  permitted limit may attract additional charges.
                </p>

                <p>
                  <b className="highlight">
                    7. Driver Duty Hours:
                  </b>
                  <br />

                  Driver working hours are regulated according to
                  transport rules. Long-duration trips may require
                  driver allowance or additional charges.
                </p>

                <p>
                  <b className="highlight">
                    8. Safety Guidelines:
                  </b>
                  <br />

                  Passengers are requested to follow all safety rules,
                  including wearing seat belts. Any damage caused to
                  the vehicle by passengers will be chargeable.
                </p>

                <p>
                  <b className="highlight">
                    9. Refusal of Service:
                  </b>
                  <br />

                  Aaradhya Travels reserves the right to refuse or
                  cancel service in case of inappropriate behavior,
                  intoxication, or unsafe travel conditions.
                </p>

                <p>
                  <b className="highlight">
                    10. Jurisdiction:
                  </b>
                  <br />

                  Any disputes arising from bookings or services will
                  be subject to local jurisdiction.
                </p>

                {/* Rental Policy */}
                <h3>Rental Policy</h3>

                <p>
                  <b className="highlight">
                    Local & Outstation Services:
                  </b>
                  <br />

                  Aaradhya Travels provides vehicles for local travel,
                  airport transfers, outstation trips, tours,
                  weddings, corporate travel, and family vacations.
                </p>

                <p>
                  <b className="highlight">
                    Toll, Parking & Taxes:
                  </b>
                  <br />

                  Toll charges, parking fees, interstate taxes, and
                  entry charges will be paid by the customer unless
                  already included in the booking package.
                </p>

                {/* Refund Policy */}
                <h3>Refund Policy</h3>

                <p>
                  <b className="highlight">
                    Eligible Refunds:
                  </b>
                  <br />

                  Refund eligibility depends on the cancellation time
                  and type of booking.
                </p>

                <p>
                  <b className="highlight">
                    Refund Processing:
                  </b>
                  <br />

                  Approved refunds will be processed within 5–7
                  working days through the original payment method.
                </p>

                <p>
                  <b className="highlight">
                    No-Show Policy:
                  </b>
                  <br />

                  No refund will be provided for no-shows or
                  last-minute cancellations.
                </p>

              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">

            <h2>Contact Us</h2>

            <p>
              For booking support or travel assistance, feel free to
              contact Aaradhya Travels:
            </p>

            <ul>

              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919529697070">
                  +91 9529697070
                </a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@aaradhyatravels99.com">
                  booking@aaradhyatravels99.com
                </a>
              </li>

              <li>
                <b className="darkcolorrr">Address:</b>
                <br />

                <h6>Aaradhya Travels</h6>

                Near RMD College, Opp. Chaudhary Parking,<br/> Warje, Pune - 411058


              </li>

            </ul>

          </div>

        </div>
      </section>
    </div>
  );
};

export default TermsConditions;